import React, { useState } from "react";
import { Link } from "react-router-dom";
import client from "../api";
import { useI18n, formatApiErrorDetail } from "../i18n";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import { Mail, ChevronLeft } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);
  const [devUrl, setDevUrl] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const origin_url = window.location.origin;
      const { data } = await client.post("/auth/forgot-password", { email, origin_url });
      setDone(true);
      if (data?.dev_reset_url) setDevUrl(data.dev_reset_url);
    } catch (e) {
      setErr(formatApiErrorDetail(e?.response?.data?.detail) || t.auth.errorGeneric);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-deep flex flex-col">
      <Nav variant="marketing" />
      <div className="flex-1 max-w-md w-full mx-auto px-6 pt-12 pb-24" data-testid="forgot-page">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-3"><Logo size="lg" linked={false} /></div>
          <h1 className="font-heading text-3xl tracking-tight">{t.auth.forgotTitle}</h1>
          <p className="text-zinc-400 mt-2 text-sm">{t.auth.forgotSub}</p>
        </div>

        {!done ? (
          <form onSubmit={submit} className="card-neon p-7 space-y-4">
            <div>
              <label className="input-label">{t.auth.email}</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-neon" data-testid="forgot-email" />
            </div>
            {err && <div className="text-xs text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="forgot-error">{err}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
              <Mail className="w-4 h-4" />
              {loading ? t.auth.processing : t.auth.forgotCta}
            </button>
            <Link to="/login" className="block text-center text-xs text-zinc-500 hover:text-neon-cyan pt-2" data-testid="forgot-back">
              <ChevronLeft className="w-3 h-3 inline" /> {t.auth.loginCta}
            </Link>
          </form>
        ) : (
          <div className="card-neon p-7 glow-cyan" data-testid="forgot-done">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-deep-card border border-line glow-cyan">
                <Mail className="w-5 h-5 text-neon-cyan" />
              </div>
              <h2 className="font-heading text-xl mt-4">{t.auth.forgotDoneTitle}</h2>
              <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{t.auth.forgotDoneSub}</p>
            </div>
            {devUrl && (
              <div className="mt-5 p-3 bg-deep-surface border border-line rounded-lg text-[11px] font-mono break-all" data-testid="forgot-dev-url">
                <div className="text-neon-yellow uppercase tracking-widest mb-1">{t.auth.devLinkLabel}</div>
                <a href={devUrl} className="text-neon-cyan hover:underline">{devUrl}</a>
              </div>
            )}
            <Link to="/login" className="btn-outline w-full justify-center mt-5 text-xs" data-testid="forgot-go-login">
              {t.auth.loginCta}
            </Link>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
